import { Action } from '@ngrx/store';
import { valueDisplay } from '../../models/valueDisplay.model';

export const CARGAR_VALUEDISPLAY_CLIENTE_CAJA = '[Value Display cliente caja] cliente caja';
export const CARGAR_VALUEDISPLAY_CLIENTE_CAJA_FAIL = '[Value Display cliente caja fail] cliente caja fail';
export const CARGAR_VALUEDISPLAY_CLIENTE_CAJA_SUCCESS = '[Value Display cliente caja success] cliente caja success';

export class CargarValueDisplayActions implements Action {
  readonly type = CARGAR_VALUEDISPLAY_CLIENTE_CAJA;
}

export class CargarValueDisplayFailActions implements Action {
  readonly type = CARGAR_VALUEDISPLAY_CLIENTE_CAJA_FAIL

  constructor( public payload: any) {}
}

export class CargarValueDisplaySuccessActions implements Action {
  readonly type = CARGAR_VALUEDISPLAY_CLIENTE_CAJA_SUCCESS

  constructor( public valuedisplay: valueDisplay[]) {}
}

export type valuedisplayAcciones = CargarValueDisplayActions |
                                   CargarValueDisplayFailActions|
                                   CargarValueDisplaySuccessActions;




// WEBPACK FOOTER //
// ./src/store/actions/clientecaja.actions.ts